import React from "react";
import style from "./style.module.scss";
import Row from "./Row";
import SkeletonRow from "../../../../../components/skeleton-loader/table/row";
import { formatCurrency } from "../../../../../../components/helper/helper";

const COLS = 11;

const IcLevelsTable = ({ data = [], loading }) => {
  const tableData = Array.isArray(data) ? data : [];

  const totals = tableData.reduce(
    (acc, r) => ({
      qual_inc: acc.qual_inc + (r.qual_inc || 0),
      ic_inc: acc.ic_inc + (r.ic_inc || 0),
      total_disc_inc: acc.total_disc_inc + (r.total_disc_inc || 0),
      ic_exp: acc.ic_exp + (r.ic_exp || 0),
      disc_profit: acc.disc_profit + (r.disc_profit || 0),
      bankcard_trans: acc.bankcard_trans + (r.bankcard_trans || 0),
      bankcard_volume: acc.bankcard_volume + (r.bankcard_volume || 0),
    }),
    {
      qual_inc: 0,
      ic_inc: 0,
      total_disc_inc: 0,
      ic_exp: 0,
      disc_profit: 0,
      bankcard_trans: 0,
      bankcard_volume: 0,
    },
  );

  const totalEffRate =
    totals.bankcard_volume > 0
      ? tableData.reduce(
          (sum, r) => sum + (r.eff_rate || 0) * (r.bankcard_volume || 0),
          0,
        ) / totals.bankcard_volume
      : 0;

  return (
    <div className={style.table_container}>
      <table className={style.table}>
        <thead>
          <tr className={style.header_row}>
            <th className={style.header_cell}>IC Level</th>
            <th className={style.header_cell}>MAS Desc</th>
            <th className={style.header_cell}>IC Group</th>
            <th className={style.header_cell}>Qual Inc</th>
            <th className={style.header_cell}>IC Inc</th>
            <th className={style.header_cell}>Total Disc Inc</th>
            <th className={style.header_cell}>Eff Rate</th>
            <th className={style.header_cell}>IC Exp</th>
            <th className={style.header_cell}>Disc Profit</th>
            <th className={style.header_cell}>Bankcard No. Trans</th>
            <th className={style.header_cell}>Bankcard Volume</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <SkeletonRow key={`ic-skeleton-${index}`} columnLength={COLS} />
            ))
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan={COLS} className={style.no_data}>
                No data to display
              </td>
            </tr>
          ) : (
            <>
              {tableData.map((row, index) => (
                <Row data={row} key={index} />
              ))}
              <tr className={style.footer_row}>
                <td className={style.footer_cell} colSpan={3}>
                  Total
                </td>
                <td className={style.footer_cell}>
                  $ {formatCurrency(totals.qual_inc)}
                </td>
                <td className={style.footer_cell}>
                  $ {formatCurrency(totals.ic_inc)}
                </td>
                <td className={style.footer_cell}>
                  $ {formatCurrency(totals.total_disc_inc)}
                </td>
                <td className={style.footer_cell}>
                  {totalEffRate.toFixed(2)}%
                </td>
                <td className={style.footer_cell}>
                  $ {formatCurrency(totals.ic_exp)}
                </td>
                <td className={style.footer_cell}>
                  $ {formatCurrency(totals.disc_profit)}
                </td>
                <td className={style.footer_cell}>
                  {totals.bankcard_trans.toLocaleString()}
                </td>
                <td className={style.footer_cell}>
                  $ {formatCurrency(totals.bankcard_volume)}
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default IcLevelsTable;
